import http from './../utils/http';

export async function fetchDonor(query: string = '', page: number = 1) {
  const {data: response} = await http.get(`/donors?query=${query}&page=${page}`);

  return response;
}
